export default "__VITE_ASSET__CBIKKrkP__"